import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";

import heroImg from '../../../assets/atsPR/mainFeed.jpg'
import logo from '../../../assets/atsPR/LOGO.webp'

import interior1 from '../../../assets/atsPR/interior-1.jpg'
import interior2 from '../../../assets/atsPR/interior-2.jpg'
import interior3 from '../../../assets/atsPR/interior-3.jpg'
import interior4 from '../../../assets/atsPR/interior-4.jpg'
import interior5 from '../../../assets/atsPR/interior-5.jpg'

import ameneties1 from '../../../assets/atsPR/ameneties-1.png'
import ameneties2 from '../../../assets/atsPR/ameneties-2.png'
import ameneties3 from '../../../assets/atsPR/ameneties-3.png'
import ameneties4 from '../../../assets/atsPR/ameneties-4.png'
import ameneties5 from '../../../assets/atsPR/ameneties-5.png'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const AtsPr = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);

    const interiors = [interior1, interior2, interior3, interior4, interior5]
    const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    }

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                ATS Picturesque Reprieves is a luxurious residential project located in Sector 152, Noida
                                Expressway. This project is designed to offer a serene and picturesque living experience, inspired by
                                Spanish architecture. Here are the main highlights
                            </p>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Project Overview:</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Project Overview:</h3>

                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <strong>Location :</strong>  Sector 152, Noida Expressway, Noida
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <strong>Concept : </strong>  Spanish-inspired living with charming landscapes and a festival-like ambiance
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <strong>RERA Approved : </strong>  UPRERAPRJ631/UPRERAPRJ396176
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Amenities:</h3>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Residences:</strong>3 BHK and 4 BHK apartments with sizes ranging from 1850 sq. ft. to 3200 sq. ft.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Clubhouse:</strong> Merged with landscape courtyards/patios, ornamentally crafted railings, windows,
                                                and green clay rooftops.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1">
                                                <IoMdCheckmarkCircle size={20} />
                                            </span>
                                            <div>
                                                <strong>Sports and Recreation:</strong> Access to world-class sports facilities including a swimming pool,
                                                indoor gymnasium, billiards room, tennis court, basketball court, cricket pitch, and multi-purpose hall.
                                            </div>
                                        </li>

                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Commercial Space :</strong>Ample open space for commercial activities.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>


                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Location Benefits:</h3>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Proximity:</strong> 5 minutes from Sector 148 Metro Station and 30 minutes from the upcoming Jewar
                                                International Airport.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Accessibility:</strong>Close to reputed schools, educational institutes, business districts, and an
                                                upcoming high-street mall, Kinghood Drive.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1">
                                                <IoMdCheckmarkCircle size={20} />
                                            </span>
                                            <div>
                                                <strong>Connectivity:</strong> 20 minutes’ drive from Noida and Delhi borders, and 25 minutes from South
                                                Delhi via DND.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Pricing:</h3>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>3 BHK (1850 sq. ft.):</strong>Starting from ₹3.03 Cr
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>3 BHK + Servant (2350 sq. ft.):</strong>Starting from ₹3.17 Cr
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1">
                                                <IoMdCheckmarkCircle size={20} />
                                            </span>
                                            <div>
                                                <strong>4 BHK + Servant (3200 sq. ft.):</strong>  Starting from ₹5.19 Cr
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Design and Architecture:</h3>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Spanish Theme:</strong>Arcades, cornice moldings, exposed rafters, and stucco.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Rustic Look:</strong> Warm, earthy, and rustic ambiance with finely crafted railings and green clay
                                                rooftops.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Additional Highlights:</h3>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-sm">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>View:</strong> Majestic views of Noida Expressway and Yamuna Expressway.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Green Living:</strong> All apartments overlook green landscapes.
                                            </div>
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            <div>
                                                <strong>Social Infrastructure:</strong> Ready access to top-notch educational institutes and social amenities.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <p className="text-md text-gray-700 my-1 text-justify">
                                ATS Picturesque Reprieves offers a blend of luxury, comfort, and connectivity, making it an ideal
                                choice for those seeking a peaceful yet vibrant living environment.                            </p>

                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Does this cover what you were looking for, or is there something specific you'd like to know more
                                about?
                            </p>                  </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 my-4">
                    Projects Highlights
                </h2>
                {openImgModal && activeImageType === "ameneties" && (
                    <ImageModal
                        images={ameneties}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {ameneties.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "ameneties")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>
            </div>
            {openImgModal && activeImageType === "interiors" && (
                <ImageModal
                    images={interiors}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {interiors.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index, "interiors")}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img
                            src={data}
                            alt="ATS"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
export default AtsPr